/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SheetGenerationSettingsIndicator = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink);
  }
}(this, function(ApiClient, CorporateStructureLink) {
  'use strict';




  /**
   * The SheetGenerationSettingsIndicator model module.
   * @module model/SheetGenerationSettingsIndicator
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>SheetGenerationSettingsIndicator</code>.
   * @alias module:model/SheetGenerationSettingsIndicator
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>SheetGenerationSettingsIndicator</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SheetGenerationSettingsIndicator} obj Optional instance to populate.
   * @return {module:model/SheetGenerationSettingsIndicator} The populated <code>SheetGenerationSettingsIndicator</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ActualWriteRuleID')) {
        obj['ActualWriteRuleID'] = ApiClient.convertToType(data['ActualWriteRuleID'], 'Integer');
      }
      if (data.hasOwnProperty('BudgetImportRuleID')) {
        obj['BudgetImportRuleID'] = ApiClient.convertToType(data['BudgetImportRuleID'], 'Integer');
      }
      if (data.hasOwnProperty('SourceID')) {
        obj['SourceID'] = ApiClient.convertToType(data['SourceID'], 'Integer');
      }
      if (data.hasOwnProperty('BaseCorporateStructureLink')) {
        obj['BaseCorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['BaseCorporateStructureLink']);
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} ActualWriteRuleID
   * @default 0
   */
  exports.prototype['ActualWriteRuleID'] = 0;
  /**
   * @member {Integer} BudgetImportRuleID
   * @default 0
   */
  exports.prototype['BudgetImportRuleID'] = 0;
  /**
   * @member {Integer} SourceID
   */
  exports.prototype['SourceID'] = undefined;
  /**
   * @member {module:model/CorporateStructureLink} BaseCorporateStructureLink
   */
  exports.prototype['BaseCorporateStructureLink'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


